export const BASE_PATH = '/app';

export const AUTH_PATH = `${BASE_PATH}/auth`;

export const CONTENT_PATH = `${BASE_PATH}/content`;

export const CONTENT_HOME_PATH = `${CONTENT_PATH}/sections`;
